import React, { useContext, useEffect, useRef, useState } from "react";
import { CustomizableProjectPagesService } from "../../../../../../api";
import { useApi } from "../../../../../hooks";
import { SectionsContext } from "../../../CustomizableForm";
import styles from "./CustomFormNumber.module.css";
import { CustomTextField } from "../../../../text-fields";

export default function CustomFormNumber({
	block,
	directApply = false,
	editMode,
	customPageId,
	hasEditorRights = false,
	isFilter = false,
	projectId,
	onGlobalUpdate,
	sectionId,
}) {
	const [localValue, setLocalValue] = useState("");
	const [activateEdit, setActivateEdit] = useState(false);
	const customTextRef = useRef(null);
	const { currentValue = "" } = block.options;
	const { call: updateCustomPage } = useApi(CustomizableProjectPagesService.updateCustomPage);
	const { updateLocalSection } = useContext(SectionsContext);

	useEffect(() => {
		if (currentValue) {
			setLocalValue(currentValue);
		}
	}, [currentValue]);
	const handleChange = (e) => {
		const { value } = e.target;
		if (/^-?\d*$/.test(value)) {
			setLocalValue(value);
			if (directApply && typeof onGlobalUpdate === "function") {
				onGlobalUpdate({ uuid: block.id, value });
			}
		}
	};
	const handleSubmit = () => {
		if (!editMode && !directApply) {
			if (localValue.length >= 0 && localValue !== currentValue) {
				if (onGlobalUpdate && typeof onGlobalUpdate === "function") {
					onGlobalUpdate({ uuid: block.id, value: localValue });
					updateLocalSection(sectionId, block.id, { currentValue: localValue });
				} else {
					updateCustomPage({ customPageId, projectId }, { uuid: block.id, value: localValue })
						.then(() => {
							updateLocalSection(sectionId, block.id, { currentValue: localValue });
						})
						.catch(console.error);
				}
			} else {
				setLocalValue(currentValue);
			}
		}
	};
	useEffect(() => {
		const handleClickOutside = (event) => {
			// eslint-disable-next-line quotes
			const dialogElement = document.querySelector('[role="dialog"]');
			if (
				activateEdit &&
				!customTextRef?.current.contains(event.target) &&
				!dialogElement?.contains(event.target)
			) {
				setActivateEdit(false);
			}
			if (!activateEdit && customTextRef?.current?.contains(event.target)) {
				setActivateEdit(true);
			}
		};
		document.addEventListener("click", handleClickOutside);
		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	}, [activateEdit, customPageId, projectId, localValue, updateCustomPage]);
	return (
		<div ref={customTextRef} data-active={activateEdit}>
			{(hasEditorRights && !block?.readOnly && (
				<CustomTextField
					fullWidth
					className={styles.numberInput}
					disabled={!(hasEditorRights && !isFilter)}
					InputProps={{ inputProps: { min: 0, inputMode: "numeric", pattern: "-?[0-9]*" } }}
					value={localValue}
					onBlur={handleSubmit}
					onChange={handleChange}
				/>
			)) || <span>{localValue}</span>}
		</div>
	);
}
